export function ExternalLinkIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_14_37436)">
        <path
          d="M13.3334 10.0008V14.6675H12.6667V15.3341H1.33335V14.6675H0.666687V3.33415H1.33335V2.66748H7.33335V4.00081H2.00002V14.0008H12V10.0008H13.3334Z"
          fill="currentColor"
        />
        <path
          d="M15.3334 0.66748V6.00081H14V3.33415H13.3334V4.00081H12.6667V4.66748H12V5.33415H11.3334V6.00081H10.6667V6.66748H10V7.33415H9.33335V8.00081H8.66669V8.66748H8.00002V9.33415H7.33335V10.0008H6.66669V10.6675H6.00002V11.3341H4.66669V10.0008H5.33335V9.33415H6.00002V8.66748H6.66669V8.00081H7.33335V7.33415H8.00002V6.66748H8.66669V6.00081H9.33335V5.33415H10V4.66748H10.6667V4.00081H11.3334V3.33415H12V2.66748H12.6667V2.00081H10V0.66748H15.3334Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_14_37436">
          <rect width="16" height="16" fill="currentColor" transform="translate(0 0.000976562)" />
        </clipPath>
      </defs>
    </svg>
  )
}
